
Fastweb.Promotions = (function($) {

  initCarousel = function() {
    $('.orbit').on('slidechange.zf.orbit', function(element, slide) {
      var bgColor = $(slide).attr('data-bg-color');
      var screenSize = $(slide).attr('data-screen-size')
      if(bgColor != '') {
        $('div.carousel_wrap.' + screenSize).css('background-color', bgColor);
      } else {
        $('div.carousel_wrap.' + screenSize).css('background-color', 'transparent');
      }

    });
  }

  return {initCarousel: initCarousel};

})(jQuery);
